/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from 'react'
import showdown from 'showdown'
import Navbar from './components/Navbar'
import SectionHome from './sections/SectionHome'
import Footer from './components/Footer'
import SectionIWant from './sections/SectionIWant'
import SectionControl from './sections/SectionControl'
import SectionCardsActive from './sections/SectionCardsActive'
import SectionUseTime from './sections/SectionUseTime'
import SectionRoof from './sections/SectionRoof'
import './App.css'
 
import { AppContext, ACTIONS, initialState } from './store'
import { getPlanPre, getPlanPos, client } from './services/api'

const converter = new showdown.Converter()

export default function App() {
  const { dispatch } = useContext(AppContext)

  async function loadPromotion(){
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: true,
    })
    let planPre
    let planPos
    try {
      planPre = (await getPlanPre())[0]
      planPos = (await getPlanPos())[0]
    } catch(e){
      planPre = initialState.plans[0]
      planPos = initialState.plans[1]
    }

    let plans = []
    if(planPre) plans.push(planPre)
    if(planPos) plans.push(planPos)

    dispatch({
      type: ACTIONS.SET_PLANS,
      payload: plans,
    })

    const mainBonus = plans.length ? plans[0].numeroMesesBonificacao : '---'
    
    dispatch({
      type: ACTIONS.SET_MAIN_BONUS,
      payload: mainBonus,
    })

    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: false,
    })

  }

  async function loadContentfull() {
    let resp;
    try {
      resp = await client.getEntry('2ZVOdk8OBDKtt3AXQS6Z7v')
      dispatch({
        type: ACTIONS.SET_REGULAMENTO,
        payload: {
          title: resp.fields.promo,
          validity: resp.fields.validade, 
          content: converter.makeHtml(resp.fields.regulamento),
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    loadPromotion()
    loadContentfull()
  }, [])

  return (
    <>
      <Navbar />
      <SectionHome />
      <SectionRoof />
      <SectionUseTime />
      <SectionCardsActive />
      <SectionControl />
      <SectionIWant />
      <Footer />
    </>
  );
}
